export const app = {
  title: 'Make.Mayku',
  homepage: 'https://make.mayku.me',
  descMeta:
    "We're building the world's first tabletop factory. A family of mini machines that let you create incredible objects. Our first product, the FormBox is a desktop vacuum former that makes beautiful things.",
  twitter: '@teammayku'
}
